
<div>
  <form class="ui form" @submit.prevent="search()">
    <h4 class="ui dividing header">検索条件</h4>
    <div class="fields">
      <div class="field">
        <label>受話ステータス</label>
        <dropdown v-model="searchForm.model.call_completed" :placeholder="'すべて'" @change="search()">
          <option value="">すべて</option>
          <option value="true">出た</option>
          <option value="false">出てない</option>
        </dropdown>
      </div>
      <div class="field">
        <label>ステータス</label>
        <dropdown v-model="searchForm.model.shop_status" :placeholder="'すべて'" @change="search()">
          <option value="">すべて</option>
          <option value="initial">未対応</option>
          <option value="active">対応中</option>
          <option value="reserved">予約確定</option>
          <option value="visited">実施済み</option>
          <option value="closed">クローズ</option>
        </dropdown>
      </div>
      <div class="field">
        <label>受付日</label>
        <datepick v-model="searchForm.model.called_at_from" :placeholder="'開始日'" @change="search()"></datepick>
      </div>
      <div class="field">
        <label>&nbsp;</label>
        <span style="display: inline-block; margin-top: 50%;">〜</span>
      </div>
      <div class="field">
        <label>&nbsp;</label>
        <datepick v-model="searchForm.model.called_at_to" :placeholder="'終了日'" @change="search()"></datepick>
      </div>
      <div class="field">
        <label>希望日</label>
        <datepick v-model="searchForm.model.event_date_from" :placeholder="'開始日'" @change="search()"></datepick>
      </div>
      <div class="field">
        <label>&nbsp;</label>
        <span style="display: inline-block; margin-top: 50%;">〜</span>
      </div>
      <div class="field">
        <label>&nbsp;</label>
        <datepick v-model="searchForm.model.event_date_to" :placeholder="'終了日'" @change="search()"></datepick>
      </div>
    </div>
    <div class="fields">
      <div class="field">
        <label>お客様電話番号</label>
        <div class="ui action input">
          <input type="text" v-model="searchForm.model.tel" placeholder="お客様電話番号">
          <button class="ui teal button">Search</button>
        </div>
      </div>
    </div>  
    <!-- <div class="fields">
      <div class="field">
          <label>人数</label>
          <input type="text" v-model="searchForm.model.num_people_from">
        </div>
        <div class="field">
          <label>&nbsp;</label>
          <span style="display: inline-block; margin-top: 50%;">〜</span>
        </div>
          <div class="field">
            <label>&nbsp;</label>
            <div class="ui action input">
            <input type="text" v-model="searchForm.model.num_people_to">
            <button class="ui teal button">Search</button>
            </div>
          </div>
     -->
  </form>

  <div class="search-result" :class="{'loading': searchForm.waiting}">
    <div class="ui vertical centered loader" :class="{'active': searchForm.waiting}"></div>
    <div class="ui horizontal divider header">検索結果</div>
    <div class="relative">
      <pagination :pager="pager" :callback="search"></pagination>
    </div>
    <table class="ui compact table">
      <thead>
        <tr>
          <th>問い合わせ番号</th>
          <th>受付日時</th>
          <th>お客様電話番号</th>
          <th class="center aligned">通話詳細</th>
          <th>ステータス</th>
          <th>名前(カナ)</th>
          <th>希望日時</th>
          <th>希望人数</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="call in calls" :key="call.id" :class="{'new': call.shop_status === 'initial'}">
          <td style="width: 200px;">{{ `GPC${call.id}` }}</td>
          <td style="width: 200px;">{{ call.created_at | formatDatetime }}</td>
          <td style="width: 200px;">{{ call.tel_display }}</td>
          <td style="width: 200px;" class="center aligned">
            <a :href="`/shopadmin/direct_calls/${call.id}`" target="_blank"><i class="large comment icon"></i></a>
          </td>
          <td style="width: 250px">
            <template>
              <span v-if="call.shop_status === 'visited'">実施済み</span>
              <dropdown v-else v-model="call.shop_status" @change="saveShopStatus(call)">
                <option value="initial">未対応</option>
                <option value="active">対応中</option>
                <option value="reserved">予約確定</option>
                <option value="closed">クローズ</option>
             </dropdown>
            </template>
          </td>
          <td>
            <div class="ellipsis" style="width: 300px">{{ call.name_kana }}</div>
          </td>
          <td style="width: 200px;">{{ call.event_date | formatDate }} {{ call.event_time }}</td>
          <td style="width: 200px;"><template v-if="call.people">{{ call.people }}人</template></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
